// extracted by mini-css-extract-plugin
export default {"gridContainer":"styles_gridContainer__HblLs"};